import { Button, Tooltip } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import { useBriefFormStore } from '../../state/brief-form-store';

export function UseSameButton() {
  const hasLastSubmittedBrief = useBriefFormStore((s) => s.lastSubmittedBrief !== null);
  const restoreLastSubmittedBrief = useBriefFormStore((s) => s.restoreLastSubmittedBrief);

  return (
    <Tooltip
      label="Generate once, then reuse the same variables"
      disabled={hasLastSubmittedBrief}
      withArrow
    >
      <Button
        variant="default"
        size="xs"
        leftSection={<IconHistory size={14} />}
        disabled={!hasLastSubmittedBrief}
        onClick={restoreLastSubmittedBrief}
        data-testid="use-same-btn"
      >
        Use same
      </Button>
    </Tooltip>
  );
}
